import { c as _c } from "react/compiler-runtime";
import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { StatusMessage } from "#components/ui/status-message.jsx";
import { BrandCardHeader } from "../brand/BrandCardHeader";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { LoadingButton } from "../ui/loading-button";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function RequestForm(t0) {
  const $ = _c(25);
  const {
    onSubmit,
    loading,
    statusMessage,
    onStatusMessageAction,
    onBackToSignIn
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      message: "",
      success: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [formState, setFormState] = useState(t1);
  let t2;
  if ($[1] !== onSubmit) {
    t2 = async e => {
      e.preventDefault();
      const formData = new FormData(e.currentTarget);
      const email = formData.get("email");
      ;
      try {
        const response = await onSubmit(email);
        setFormState({
          success: response.success,
          message: response.message
        });
      } catch (t3) {
        const error = t3;
        setFormState({
          success: false,
          message: error instanceof Error ? error.message : "An error occurred"
        });
      }
    };
    $[1] = onSubmit;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleSubmit = t2;
  if (statusMessage && onStatusMessageAction) {
    let t3;
    if ($[3] !== statusMessage.message || $[4] !== statusMessage.variant) {
      t3 = /*#__PURE__*/_jsx(StatusMessage, {
        message: statusMessage.message,
        variant: statusMessage.variant
      });
      $[3] = statusMessage.message;
      $[4] = statusMessage.variant;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== onStatusMessageAction) {
      t4 = /*#__PURE__*/_jsx(Button, {
        onClick: onStatusMessageAction,
        className: "w-full",
        children: "Continue"
      });
      $[6] = onStatusMessageAction;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
      t5 = /*#__PURE__*/_jsxs("div", {
        className: "space-y-4",
        children: [t3, t4]
      });
      $[8] = t3;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: "email",
        className: "block text-sm font-medium",
        children: "E-post"
      }), /*#__PURE__*/_jsx(Input, {
        id: "email",
        name: "email",
        type: "email",
        required: true
      })]
    });
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== loading) {
    t4 = /*#__PURE__*/_jsx(LoadingButton, {
      type: "submit",
      className: "w-full",
      loading: loading,
      children: "Beg\xE4r \xE5terst\xE4llning av l\xF6senord"
    });
    $[12] = loading;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== formState.message || $[15] !== formState.success) {
    t5 = formState.message && /*#__PURE__*/_jsx(StatusMessage, {
      message: formState.message,
      variant: formState.success ? "success" : "error"
    });
    $[14] = formState.message;
    $[15] = formState.success;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = /*#__PURE__*/_jsx(ArrowLeft, {
      className: "mr-2 h-4 w-4"
    });
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== onBackToSignIn) {
    t7 = /*#__PURE__*/_jsxs(Button, {
      type: "button",
      variant: "outline",
      className: "w-full",
      onClick: onBackToSignIn,
      children: [t6, "Tillbaka"]
    });
    $[18] = onBackToSignIn;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== handleSubmit || $[21] !== t4 || $[22] !== t5 || $[23] !== t7) {
    t8 = /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit,
      className: "space-y-4",
      children: [t3, t4, t5, t7]
    });
    $[20] = handleSubmit;
    $[21] = t4;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
export default function RequestResetPasswordCard(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(BrandCardHeader, {
      title: "Beg\xE4r \xE5terst\xE4llning av l\xF6senord",
      subtitle: "Ange din e-postadress f\xF6r att beg\xE4ra \xE5terst\xE4llning av l\xF6senord"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = /*#__PURE__*/_jsxs(Card, {
      className: "bg-card m-auto w-screen overflow-y-auto rounded-none shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
      children: [t0, /*#__PURE__*/_jsx(CardContent, {
        className: "p-6",
        children: /*#__PURE__*/_jsx(RequestForm, {
          ...props
        })
      })]
    });
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}